import React from "react";
import Start from "./Start";
import Business from "./Business";
import Principal from "./Principal";
import Account from "./Account";
import Financial from "./Financial";
import Payment from "./Payment";
import Review from "./Review";

const STEPS = [Start, Business, Principal, Account, Financial, Payment, Review];

export default function ApplicationStep({ step, ...props }) {
  const Step = STEPS[step] || Start;
  return <Step {...props} />;
}
